import { apiRequest } from "./api";

export function listMyMessages(params = {}) {
  const search = new URLSearchParams();
  if (params.sender_type) search.set("sender_type", params.sender_type);
  if (params.limit) search.set("limit", String(params.limit));
  if (params.offset) search.set("offset", String(params.offset));
  const query = search.toString();
  return apiRequest(query ? `/api/v1/me/messages?${query}` : "/api/v1/me/messages");
}

export function getUnreadMessageCount() {
  return Promise.all([
    apiRequest("/api/v1/me/messages/unread-count"),
    apiRequest("/api/v1/me/direct/unread-count"),
  ]).then(([system, direct]) => ({
    ok: true,
    system_count: Number(system && system.count) || 0,
    direct_count: Number(direct && direct.count) || 0,
    count: (Number(system && system.count) || 0) + (Number(direct && direct.count) || 0),
  }));
}

export function listDirectConversations(params = {}) {
  const search = new URLSearchParams();
  if (params.limit) search.set("limit", String(params.limit));
  if (params.offset) search.set("offset", String(params.offset));
  const query = search.toString();
  return apiRequest(query ? `/api/v1/me/direct/conversations?${query}` : "/api/v1/me/direct/conversations");
}

export function listDirectMessages(conversationId, params = {}) {
  const search = new URLSearchParams();
  if (params.limit) search.set("limit", String(params.limit));
  if (params.offset) search.set("offset", String(params.offset));
  const query = search.toString();
  const path = `/api/v1/me/direct/conversations/${encodeURIComponent(conversationId)}/messages`;
  return apiRequest(query ? `${path}?${query}` : path);
}

export function sendDirectMessage(payload) {
  return apiRequest("/api/v1/me/direct/messages", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function getDirectUnreadCount() {
  return apiRequest("/api/v1/me/direct/unread-count");
}

export function markMessageRead(messageId) {
  return apiRequest(`/api/v1/me/messages/${encodeURIComponent(messageId)}/read`, { method: "PATCH" });
}

export function markAllMessagesRead() {
  return apiRequest("/api/v1/me/messages/read-all", { method: "POST" });
}
